export const projects = [
  {
    id: 'ml-classifier',
    title: 'IT Ticket Classifier',
    subtitle: 'NLP · Machine Learning',
    color: '#CC1100',
    tag: 'ML / NLP',
    description: `A text classification system that automatically routes IT support tickets 
    to the correct department using TF-IDF vectorization and a LinearSVC model trained on 
    ~48,000 unique ticket descriptions across 8 categories. Implements confidence thresholding 
    at 80% to achieve 94.4% precision on auto-classified tickets, with low-confidence 
    tickets flagged for manual review.`,
    tech: ['Python', 'scikit-learn', 'TF-IDF', 'LinearSVC', 'AWS Lambda'],
    github: 'https://github.com/NathanielSong/YOUR_REPO',
    hasDemo: true,
    demoType: 'classifier',
  },
  {
    id: 'knot-theory',
    title: 'Knot Theory API',
    subtitle: 'Mathematics · Go',
    color: '#1A4FCC',
    tag: 'Mathematics',
    description: `A Go implementation for computing GPV finite-type invariants from Gauss 
    diagrams, exposed as an AWS Lambda API. Rewrites a Python knot theory tool with three 
    HTTP endpoints returning base64-encoded PNGs and CSV data.`,
    tech: ['Go', 'AWS Lambda', 'API Gateway', 'Knot Theory'],
    github: 'https://github.com/NathanielSong/GaussDiagramConversion',
    hasDemo: false,
  },
  {
    id: 'kaggle-predictor',
    title: 'Kaggle Upgrade Predictor',
    subtitle: 'Machine Learning · XGBoost',
    color: '#2E7A30',
    tag: 'Machine Learning',
    description: `Customer upgrade prediction model built for a Kaggle competition. 
    Handles class imbalance using SMOTE and compares KNN, SVM, and XGBoost classifiers.`,
    tech: ['Python', 'XGBoost', 'SMOTE', 'scikit-learn'],
    github: 'https://github.com/NathanielSong/YOUR_REPO',
    hasDemo: false,
  },
];